import styled from 'styled-components';

export interface IProps {
  sizePx?: number;
  borderPx?: number;
  marginLeftPx?: number;
}

export const SLoader = styled.div<IProps>`
  width: ${({ sizePx }) => (sizePx ? sizePx : 15)}px;
  height: ${({ sizePx }) => (sizePx ? sizePx : 15)}px;
  border: ${({ borderPx }) => (borderPx ? borderPx : 2)}px solid ${({ theme }) => theme.colors.primaryText};
  margin-left: ${({ marginLeftPx }) => (marginLeftPx ? marginLeftPx : 0)}px;

  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  &.search-criteria-loader {
    left: 0;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    right: 0;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &.landing-loader {
    position: relative;
    left: 50%;

    &.chart-loader {
      top: 25%;
      left: 45%;
    }

    &.start-ending-loader-chart {
      top: 0;
    }
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const SLoaderCenter = styled(SLoader)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
